import React from 'react';
import styles from './styles.module.scss';

export const ChartLabelTab = ({
  chart,
  active,
  label,
  updateSelectedChart,
}) => {
  return (
    <span
      onClick={() => updateSelectedChart(chart)}
      className={active ? styles.activeTab : styles.inactiveTab}
    >
      {label}
    </span>
  );
};

export default ChartLabelTab;
